module.exports = __webpack_public_path__ + "static/media/solicitud_de_acceso_usuario_externo.1f73f22c.pdf";